import { z } from 'zod'

const Id = z.number().int().positive()
const RichText = z.string().max(20_000)

export const ShareableListMutationList = z.object({
  id: Id,
  name: z.string(),
  slug: z.string(),
})

export const CreateShareableListInput = z.object({
  name: z.string().trim().min(1),
  description: RichText.optional(),
  venueGroupId: Id.optional(),
  spaceId: Id.optional(),
})

export const CreateShareableListOutput = z.object({
  list: ShareableListMutationList,
  spaceAdded: z.boolean(),
})

export const CloneShareableListInput = z.object({
  sourceId: Id,
  name: z.string().trim().min(1),
  description: RichText.optional(),
})

export const CloneShareableListOutput = ShareableListMutationList

export const UpdateShareableListInput = z.object({
  id: Id,
  name: z.string().trim().min(1),
  description: RichText.optional(),
})

export const UpdateShareableListOutput = ShareableListMutationList.extend({
  criteria: RichText.nullable(),
})

export const DeleteShareableListInput = z.object({
  id: Id,
})

export const DeleteShareableListOutput = z.object({
  ok: z.literal(true),
})

export const AddShareableListMembershipInput = z.object({
  listId: Id,
  spaceId: Id,
})

export const AddShareableListMembershipOutput = z.object({
  id: Id,
  alreadyExists: z.boolean(),
})

export const RemoveShareableListMembershipInput = z.object({
  membershipId: Id,
})

export const RemoveShareableListMembershipOutput = z.object({
  ok: z.literal(true),
})

export const UpdateShareableListMembershipInput = z.object({
  membershipId: Id,
  shareableNotes: RichText.nullable(),
})

export const UpdateShareableListMembershipOutput = z.object({
  id: Id,
  shareable_notes: RichText.nullable(),
  updated_at: z.string(),
})

export const ReorderShareableListMembershipsInput = z.object({
  listId: Id,
  membershipIds: z.array(Id).min(1),
})

export const ReorderShareableListMembershipsOutput = z.object({
  ok: z.literal(true),
})
